import { createFileRoute } from '@tanstack/react-router';
import DocumentCreate from '~/containers/DocumentCreate';

export const Route = createFileRoute('/documents/$folderId/newDocument')({
  component: DocumentCreate,
  validateSearch(search): { from?: string } {
    return {
      from: (search.from as string) || undefined,
    };
  },
});
